import React from 'react';
import AuthService from './authService.js';

class FileForDownloadService extends React.Component
{

    static GetNumberOfUndownloadedFiles ()
    {
        const url = "/api/FileForDownload/GetNumberOfUndownloadedFiles/?clearCache=true";
        const authService = AuthService.getInstance();
        return authService.CallBackendFunction(url);
    }

    static GetFileList () 
    {
        const url = "/api/FileForDownload/GetFileListOfTheUser/?clearCache=true";
        const authService = AuthService.getInstance();
        return authService.CallBackendFunction(url);
    }


    static DownloadFileById (id)
    {
        const url = `/api/FileForDownload/DownloadFileById/${id}`;
        const authService = AuthService.getInstance();
        return authService.CallBackendFunction(url);
    }

    static DeleteFileById (id)
    {
        const url = `/api/FileForDownload/DeleteFileById/${id}`;
        const authService = AuthService.getInstance();
        return authService.CallBackendFunctionDelete(url);
    }


}

export default FileForDownloadService;